import React, { useEffect, useRef, useState } from "react";
import { findInitialSchoolYear } from "../../../util/schoolYear";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import useAllForms from "../../../hooks/useAllForms";
import { useLocation } from "react-router-dom";
import useComponentsToForms from "../../../hooks/useComponentsToForms";
import DynamicComponentsRenderer from "../../../unicomponents/formComponents/DynamicComponentsRenderer";
import useOrganizationSetting from "../../../hooks/useOrganizationSetting";
import useTermPeriod from "../../../hooks/useTermPeriod";
import { setTermIdByToday } from "../../../util/dateRelated";
import { generateRegistrationRows } from "../../../util/dealingArrObj";
import useRegistrationInfo from "../../../hooks/useRegistrationInfo";
import { useUIContext } from "../../../context/UIContext";
import FiltersBar from "../../../unicomponents/Dropdowns/FilterBar";
import ReportCardButtonBar from "./components/ReportCardButtonBar";
// import styles from "./css/ReportCard.module.css";

import { useReactToPrint } from "react-to-print";
import ApprovalProcess from "../../../unicomponents/approvalForms/ApprovalProcess";
import useDocumentForms from "../../../hooks/useDocumentForms";
import { useAuthContext } from "../../../context/AuthContext";
import useApprovalRequests from "../../../hooks/useApprovalRequest";
import LoadingInside from "../../../unicomponents/LoadingInside";
import LoadingModal from "../../../unicomponents/LoadingModal";
import SimpleAlertMessageBlock from "../../../unicomponents/SimpleAlertMessageBlock";
import { checkHrteachers } from "../../../util/checkPermissions";
import { useTranslation } from "react-i18next";
//${styles.tableStyle} 이런식으로 씀. class에 삽입

/* 
우엥... 인쇄까지 순탄하게 된다. 예전에 인쇄 엄청 어려워서 한참 시간 걸리고도 만족스럽게 못했는데...

좋아, 이제 할일
1. 인쇄 안 되는 윗대가리 디자인
2. 본문에 들어갈 컴포넌트들 개발
3. 넣어서 인쇄 확인
*/

export default function ReportCard() {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];
  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    organPathForSort: "/",
    termId: "",
    selectedTeacherId: "",
    selectedLessonId: "",
  });
  const [termId, setTermId] = useState("");
  const [currentPeriod, setCurrentPeriod] = useState({});
  const [studentList, setStudentList] = useState([]);
  const [studentListForApproval, setStudentListForApproval] = useState([]);
  const [keyData, setKeyData] = useState({});
  // const [validateInput, setValidateInput] = useState({});
  const [modifyMode, setModifyMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [approvalLines, setApprovalLines] = useState([]);
  const [studentApprovalRequests, setStudentApprovalRequests] = useState([]);
  const [showPageNumbers, setShowPageNumbers] = useState(false);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [bulkPrintMode, setBulkPrintMode] = useState(false);
  const [bulkStudents, setBulkStudents] = useState([]);
  const [bulkApprovalData, setBulkApprovalData] = useState({});
  const [bulkPrintCooldown, setBulkPrintCooldown] = useState(0); // 쿨다운 종료 시간 (timestamp)
  const [, forceUpdate] = useState({}); // 리렌더링 트리거용

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "",
    menu_id: "",
  });

  const conditions = {
    schoolid: schoolId,
    form_category: "reportCard",
  };

  const [formQueryConditions, setFormQueryConditions] = useState({
    schoolid: schoolId,
    form_id: "",
  });

  const [approvalData, setApprovalData] = useState({
    schoolid: schoolId,
    document_type: "fixedForm",
    document_category: "reportCard",
    document_name: "",
  });

  const [approvalConditions, setApprovalConditions] = useState({
    schoolid: schoolId,
    document_type: "fixedForm",
    document_category: "reportCard",
    document_name: "",
  });

  const requestType = "schoolTerm";

  const [requestTitle, setRequestTitle] = useState("");

  const [documentFormData, setDocumentFormData] = useState([]);

  const {
    allFormsQuery: { data: allFormsData },
  } = useAllForms(conditions);

  const {
    componentsToFormsQuery: { data: componentsToFormsData = [], isLoading },
  } = useComponentsToForms(formQueryConditions);

  const {
    settingQuery: { data: settingData },
  } = useOrganizationSetting({ schoolid: schoolId });

  const {
    termPeriodQuery: { data: termPeriodData },
  } = useTermPeriod({ schoolid: schoolId });

  const {
    registrationInfoQuery: {
      isLoading: isLoadingRegi,
      data: registrationInfoData,
    },
    hrTeachersQuery: { data: hrTeachersData },
  } = useRegistrationInfo({ schoolid: schoolId }, { hrTeachers: true });

  const { getDocumentForms } = useDocumentForms();
  const getDocumentFormsRef = useRef(getDocumentForms);

  const { getApprovalRequestsByUserId, getBulkApprovalRequests } =
    useApprovalRequests();
  const getApprovalRequestsByUserIdRef = useRef(getApprovalRequestsByUserId);
  const getBulkApprovalRequestsRef = useRef(getBulkApprovalRequests);

  const { user, hasPermission } = useAuthContext();

  const { setIsLoadingModal, handleToastCenterTop, handleToastCenterBottom } =
    useUIContext();

  // 자식 컴포넌트들의 서버 데이터 로딩을 중앙에서 추적 (mutation + query 합계)
  const fetchingCount = useIsFetching();
  const mutatingCount = useIsMutating();
  const isBusy = fetchingCount + mutatingCount > 0;

  const [dataReady, setDataReady] = useState(true);
  const hasSeenBusyRef = useRef(false);
  const settleTimerRef = useRef(null);

  // 쿨다운 상태 계산
  const now = Date.now();
  const isCooldownActive = now < bulkPrintCooldown;
  const cooldownRemaining = isCooldownActive
    ? Math.ceil((bulkPrintCooldown - now) / 1000)
    : 0;

  // 쿨다운 타이머 (1초마다 업데이트)
  useEffect(() => {
    if (isCooldownActive) {
      const timer = setInterval(() => {
        forceUpdate({}); // 강제 리렌더링
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isCooldownActive, forceUpdate]);

  // 페이지 visibility 변경 시 강제 업데이트 (인쇄 취소 후 돌아올 때)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && isCooldownActive) {
        forceUpdate({}); // 페이지가 다시 보일 때 강제 업데이트
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isCooldownActive, forceUpdate]);

  useEffect(() => {
    if (allFormsData) {
      setFormQueryConditions((prev) => ({
        ...prev,
        form_id: allFormsData[0].id,
      }));

      setActiveMenu({
        menu_name: allFormsData[0].form_name,
        menu_id: allFormsData[0].id,
      });
      setApprovalData((prev) => ({
        ...prev,
        document_name: allFormsData[0].form_name,
      }));
    }
  }, [allFormsData]);

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;
    // let initialUsername = null;

    if (
      filters.schoolYear === null &&
      settingData &&
      settingData.length > 0 &&
      registrationInfoData &&
      termPeriodData !== undefined
    ) {
      const initialData = findInitialSchoolYear(settingData, {
        periodData: termPeriodData,
      })?.row;
      if (!initialData) return;

      initialSchoolYear = initialData.school_year;
      initialSchoolYearId = initialData.id;
      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      if (termPeriodData) {
        setTermIdByToday(termPeriodData, setTermId, initialSchoolYearId);
      }

      //학생 리스트
      if (initialSchoolYear) {
        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          initialSchoolYear,
          filters.organPathForSort
        );

        if (hasPermission(null, "can_read")) {
          setStudentList(sortedRows);
        } else if (checkHrteachers(hrTeachersData, "", filters.schoolYear)) {
          const filteredHrTeachersData = hrTeachersData.filter(
            (student) => student.schoolYear === filters.schoolYear
          );
          const filteredRows = sortedRows.filter((r) =>
            filteredHrTeachersData.find((data) => data.username === r.username)
          );
          setStudentList(filteredRows);

          handleToastCenterBottom(t("common.messages.homeroomReadOnly"));
        }
      }
    } else {
      //rows 데이터처리
      if (registrationInfoData && settingData) {
        // console.log("registrationInfoData", registrationInfoData);
        // console.log("filters", filters);

        const sortedRows = generateRegistrationRows(
          registrationInfoData,
          settingData,
          filters.schoolYear,
          filters.organPathForSort
        );

        // console.log("sortedRows", sortedRows);
        if (hasPermission(null, "can_read")) {
          setStudentList(sortedRows);
        } else if (checkHrteachers(hrTeachersData, "", filters.schoolYear)) {
          const filteredHrTeachersData = hrTeachersData.filter(
            (student) => student.schoolYear === filters.schoolYear
          );
          const filteredRows = sortedRows.filter((r) =>
            filteredHrTeachersData.find((data) => data.username === r.username)
          );
          setStudentList(filteredRows);
        }

        // setStudentList(sortedRows);
      }
    }
  }, [
    filters,
    filters.schoolYear,
    handleToastCenterBottom,
    hasPermission,
    hrTeachersData,
    registrationInfoData,
    settingData,
    termPeriodData,
    t,
  ]);

  useEffect(() => {
    if (hrTeachersData && filters.schoolYear)
      if (checkHrteachers(hrTeachersData, "", filters.schoolYear)) {
        const thisYearData = hrTeachersData.filter(
          (r) => r.schoolYear === filters.schoolYear
        );
        const splited = thisYearData[0].organization_path.split("/");

        // console.log("splited", splited);
        // console.log("filterOrgan", filterOrgan);

        setFilters((prevFilter) => ({
          ...prevFilter,
          hierarchyOneId: splited[2],
          hierarchyTwoId: splited[3],
          hierarchyThreeId: splited[4],
          organPathForSort: thisYearData[0].organization_path,
        }));
      }
  }, [filters.schoolYear, hrTeachersData]);

  useEffect(() => {
    if (termPeriodData) {
      const nowPeriod = termPeriodData.filter(
        (r) => r.id.toString() === termId.toString()
      )[0];

      if (nowPeriod) {
        // console.log("nowPeriod", nowPeriod);
        setCurrentPeriod(nowPeriod);
      } else {
        setCurrentPeriod({});
      }
    }
  }, [termId, termPeriodData]);

  useEffect(() => {
    if (studentList && filters.selectedStudent) {
      const selectedObject = studentList.find(
        (r) => r.username === filters.selectedStudent
      );

      if (currentPeriod && Object.keys(currentPeriod).length > 0) {
        setKeyData({
          ...selectedObject,
          currentPeriod: currentPeriod,
        });

        const makeConditions = {
          schoolid: schoolId,
          target_username: filters.selectedStudent,
          document_id: documentFormData[0]?.id || "",
          request_type: requestType,
          term_id: currentPeriod?.id,
        };

        if (makeConditions.document_id) {
          setApprovalConditions(makeConditions);

          getApprovalRequestsByUserIdRef.current.mutate(makeConditions, {
            onSuccess: (data) => {
              setStudentApprovalRequests(data);
            },
            onError: (error) => {
              console.error(error); // 일단 콘솔에 에러를 출력합니다.
              console.error("위와 같은 에러가 났으니 고치삼");
              alert(t("common.messages.errorAlert") + error.message);
            },
          });
        } else {
          setStudentApprovalRequests([]);
        }
      } else {
        setKeyData(selectedObject);
      }
    } else {
      setKeyData({});
    }
  }, [
    currentPeriod,
    documentFormData,
    filters.selectedStudent,
    schoolId,
    studentList,
    t,
  ]);

  useEffect(() => {
    if (approvalData && approvalData.document_name.length > 0) {
      getDocumentFormsRef.current.mutate(approvalData, {
        onSuccess: (data) => {
          setDocumentFormData(data);
        },
        onError: (error) => {
          console.error(error); // 일단 콘솔에 에러를 출력합니다.
          console.error("위와 같은 에러가 났으니 고치삼");
          alert(t("common.messages.errorAlert") + error.message);
        },
      });
    }
  }, [approvalData, t]);

  // keyData 변경(학생 선택/학기 변경) 시 데이터 로딩 시작으로 간주
  useEffect(() => {
    if (!keyData || !keyData.username) {
      setDataReady(true);
      return;
    }
    hasSeenBusyRef.current = false;
    setDataReady(false);
  }, [keyData]);

  // isBusy 전이 감시: 로딩이 settle되면 dataReady true
  useEffect(() => {
    if (dataReady) return;
    if (isBusy) {
      hasSeenBusyRef.current = true;
      if (settleTimerRef.current) clearTimeout(settleTimerRef.current);
      settleTimerRef.current = null;
      return;
    }
    // isBusy === 0: wave 사이 gap(짧음)과 첫 wave 대기(김)를 구분
    const delay = hasSeenBusyRef.current ? 500 : 1500;
    settleTimerRef.current = setTimeout(() => setDataReady(true), delay);
    return () => settleTimerRef.current && clearTimeout(settleTimerRef.current);
  }, [isBusy, dataReady]);

  const handleQueryCondition = (item) => {
    if (item?.id) {
      setFormQueryConditions((prev) => ({
        ...prev,
        form_id: item.id,
      }));

      setApprovalData((prev) => ({
        ...prev,
        document_name: item.form_name,
      }));
    }
  };

  const handleExtraFunction = () => {
    getApprovalRequestsByUserIdRef.current.mutate(approvalConditions, {
      onSuccess: (data) => {
        setStudentApprovalRequests(data);
      },
      onError: (error) => {
        console.error(error); // 일단 콘솔에 에러를 출력합니다.
        console.error("위와 같은 에러가 났으니 고치삼");
        alert(t("common.messages.errorAlert") + error.message);
      },
    });
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;
    const dataName = e.target.selectedOptions[0].getAttribute("data-name");
    let organPath = "";
    if (!dataName) {
      organPath = "N/A";
    } else {
      organPath = dataName + "/" + value;
    }
    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, value);
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(termPeriodData, setTermId, filters.schoolYearId, value);
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
        organPathForSort: "N/A",
        selectedStudent: "",
      }));

      setTermIdByToday(
        termPeriodData,
        setTermId,
        filters.schoolYearId,
        filters.hierarchyOneId,
        value
      );
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
        organPathForSort: organPath,
        selectedStudent: "",
      }));
    }

    if (name === "students") {
      setFilters((filters) => ({
        ...filters,
        selectedStudent: value,
      }));
    }

    if (name === "termDate") {
      setTermId(value);
    }
  };

  // const showAllInfo = () => {
  //   if (filters.selectedStudent === "") {
  //     handleToastCenterTop("학생을 선택하세요.");
  //     setValidateInput((prev) => ({ ...prev, user: true }));
  //     return;
  //   } else {
  //     setValidateInput((prev) => ({ ...prev, user: false }));
  //   }
  // };

  const handleModifyMode = (e) => {
    e.preventDefault();

    if (
      keyData.school_year &&
      keyData[1] &&
      keyData[2] &&
      keyData[3] &&
      keyData.currentPeriod?.term_name &&
      keyData.fullname
    ) {
      if (
        !hasPermission(
          "",
          "can_update",
          checkHrteachers(hrTeachersData, keyData.username, keyData.school_year)
        )
      ) {
        handleToastCenterTop(t("common.messages.homeroomModifyOnly"));
        return;
      }

      const onOff = e.target.name;
      if (onOff === "modifyOn") {
        setModifyMode(false);
      } else {
        setModifyMode(true);
      }
    } else {
      console.log(
        "keyData is incomplete. Please ensure all data is available."
      );
      handleToastCenterTop(t("teacher.printingRelated.canModifyAfterSelect"));
    }
  };

  const adminMode = () => {
    console.log("adminMode 임");
  };

  // const addPageNumbers = () => {
  //   const pages = document.querySelectorAll(".print-page");
  //   pages.forEach((page, index) => {
  //     const footer = document.createElement("div");
  //     footer.className = "page-footer";
  //     footer.innerText = `Page ${index + 1}`;
  //     page.appendChild(footer);
  //   });
  // };

  const triggerPrint = useReactToPrint({
    content: () => {
      return contentToPrint.current;
    },
    documentTitle: `${keyData.school_year}-${keyData?.currentPeriod?.term_name}-${keyData[1]}-${keyData[2]}-${keyData[3]}-${keyData.fullname}`,
    onBeforePrint: () => {
      const content = contentToPrint.current;
      if (content) {
        content.style.width = "210mm";
        content.style.height = "auto";
      }
    },
    // onAfterPrint: () => {
    //   console.log("after printing...");
    //   // Cleanup the page numbers after printing
    //   document.querySelectorAll(".page-footer").forEach((el) => el.remove());
    // },
    removeAfterPrint: true,
    pageStyle: `
    @media print {
    body { background-color: transparent !important; }
      @page {
        size: A4 portrait;
        margin: 10mm;
      }
      .no-print {
        display: none !important;
      }        
      .print-page {
        display: block;
        width: 210mm;
        margin: auto;
      }
      .page-break {
        page-break-before: always;
      }        
      .pageBreakAfter {
        page-break-before: always;
        page-break-after: avoid;
      }        
    }
    ${
      showPageNumbers
        ? `
        @page {
          @bottom-center {
            content: counter(page);
            font-size: 10pt;
            margin-bottom: 5mm;
          }
        }
      `
        : ""
    }
    body {
      counter-reset: page;
    }
    
    .print-page {
      counter-increment: page;
    }
    
    table {
      page-break-inside: auto;
    }
    
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    
    thead {
      display: table-header-group;
    }
    
    tfoot {
      display: table-footer-group;
    }
  }
  `,
  });

  // 일단 페이지 넘버는 포기
  // body {
  //   counter-reset: page;
  // }

  //       tfoot:before {
  //         counter-increment: page;
  //         content: "Page " counter(page);
  //         position: fixed;
  //         bottom: 0;
  //         left: 0;
  //         right: 0;
  //         text-align: center;
  //       }

  // .page-footer {
  //   position: fixed;
  //   bottom: 10mm;
  //   left: 0;
  //   right: 0;
  //   text-align: center;
  // }

  const contentToPrint = useRef(null);
  const bulkContentRef = useRef(null);

  const isDataLoading = !dataReady && !!keyData?.username;

  const handlePrint = () => {
    // console.log("keyData", keyData);
    if (isDataLoading) {
      handleToastCenterTop("데이터를 불러오는 중입니다. 잠시만 기다려주세요.");
      return;
    }
    if (
      keyData.school_year &&
      keyData[1] &&
      keyData[2] &&
      keyData[3] &&
      keyData.currentPeriod?.term_name &&
      keyData.fullname
    ) {
      triggerPrint();
    } else {
      console.log(
        "keyData is incomplete. Please ensure all data is available."
      );
      handleToastCenterTop(t("common.messages.printAfterSelectStudent"));
    }
  };

  // 렌더링 완료 체크 함수
  const checkRenderingComplete = () => {
    return new Promise((resolve) => {
      let attempts = 0;
      const maxAttempts = 50; // 최대 25초 대기 (500ms * 50)

      const checkInterval = setInterval(() => {
        attempts++;

        if (!bulkContentRef.current) {
          if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
            resolve(false);
          }
          return;
        }

        // Loading... 텍스트가 있는지 확인
        const hasLoadingText =
          bulkContentRef.current.textContent.includes("Loading");

        // 실제 컨텐츠가 렌더링되었는지 확인
        const hasActualContent = bulkContentRef.current.children.length > 0;
        const hasStudentContent =
          bulkContentRef.current.querySelectorAll("[data-student-content]")
            .length >= bulkStudents.length;

        // 실제 렌더링된 컴포넌트가 있는지 확인 (테이블, 폼 요소 등)
        const renderedComponents = bulkContentRef.current.querySelectorAll(
          "table, form, input, textarea, select, .form-control"
        );
        const hasRenderedComponents =
          renderedComponents.length > bulkStudents.length * 2; // 학생당 최소 2개 요소

        // 충분한 텍스트 컨텐츠가 있는지 확인 (각 학생마다 최소 텍스트 양)
        const textContent = bulkContentRef.current.textContent.trim();
        const hasEnoughContent = textContent.length > bulkStudents.length * 20; // 학생당 최소 20자

        // console.log(`렌더링 체크 ${attempts}/${maxAttempts}:`, {
        //   hasLoadingText,
        //   hasActualContent,
        //   hasStudentContent,
        //   hasRenderedComponents,
        //   hasEnoughContent,
        //   contentLength: textContent.length,
        //   renderedComponentsCount: renderedComponents.length,
        //   studentsCount: bulkStudents.length,
        // });

        if (
          !hasLoadingText &&
          hasActualContent &&
          hasStudentContent &&
          hasRenderedComponents &&
          hasEnoughContent
        ) {
          clearInterval(checkInterval);
          resolve(true);
        } else if (attempts >= maxAttempts) {
          clearInterval(checkInterval);
          console.warn("렌더링 완료 대기 시간 초과, 강제 인쇄 진행");
          resolve(true); // 시간 초과 시에도 인쇄 진행
        }
      }, 500);
    });
  };

  const handleBulkPrint = async () => {
    // 쿨다운 체크
    const now = Date.now();
    if (now < bulkPrintCooldown) {
      const remainingSeconds = Math.ceil((bulkPrintCooldown - now) / 1000);
      handleToastCenterTop(
        `반일괄인쇄는 ${remainingSeconds}초 후에 다시 사용할 수 있습니다.`
      );
      return;
    }

    // 쿨다운 시작 (30초)
    setBulkPrintCooldown(now + 10000);

    // 현재 선택된 반의 모든 학생 필터링
    const classStudents = studentList.filter(
      (student) =>
        student.organization_path === filters.organPathForSort &&
        filters.organPathForSort !== "/" &&
        filters.organPathForSort !== "N/A"
    );

    if (classStudents.length === 0) {
      handleToastCenterTop(
        "해당 반에 학생이 없습니다. 학급을 먼저 선택해주세요."
      );
      setBulkPrintCooldown(0); // 에러 시 쿨다운 해제
      return;
    }

    if (!currentPeriod || Object.keys(currentPeriod).length === 0) {
      handleToastCenterTop("학기 정보가 설정되지 않았습니다.");
      setBulkPrintCooldown(0); // 에러 시 쿨다운 해제
      return;
    }

    try {
      handleToastCenterTop(
        `${classStudents.length}명의 성적표를 준비 중입니다...`
      );

      // 학생 데이터에 currentPeriod 추가
      const studentsWithPeriod = classStudents.map((student) => ({
        ...student,
        currentPeriod: currentPeriod,
      }));

      setBulkStudents(studentsWithPeriod);
      setBulkPrintMode(true);

      // 일괄 승인 데이터 조회
      if (documentFormData.length > 0 && currentPeriod?.id) {
        const bulkApprovalConditions = {
          schoolid: schoolId,
          target_usernames: studentsWithPeriod.map((s) => s.username),
          document_id: documentFormData[0]?.id,
          request_type: requestType,
          term_id: currentPeriod.id,
        };

        getBulkApprovalRequestsRef.current.mutate(bulkApprovalConditions, {
          onSuccess: (data) => {
            // 배열을 학생별로 그룹화
            const groupedData = data.reduce((acc, item) => {
              const username = item.target_username;
              if (!acc[username]) {
                acc[username] = [];
              }
              acc[username].push(item);
              return acc;
            }, {});

            setBulkApprovalData(groupedData);
          },
          onError: (error) => {
            console.error("일괄 승인 데이터 조회 실패:", error);
            setBulkApprovalData({});
          },
        });
      }

      // 화면에 표시한 후 렌더링 완료까지 대기
      const isRenderingComplete = await checkRenderingComplete();

      if (isRenderingComplete) {
        handleToastCenterTop("렌더링 완료! 잠시 후 인쇄를 시작합니다.");

        // 사용자가 미리보기를 확인할 수 있도록 3초 대기
        setTimeout(() => {
          triggerBulkPrint();
        }, 3000);
      } else {
        handleToastCenterTop("렌더링에 실패했습니다. 다시 시도해주세요.");
        setBulkPrintMode(false);
        setBulkStudents([]);
        setBulkApprovalData({});
      }
    } catch (error) {
      console.error("일괄 인쇄 오류:", error);
      handleToastCenterTop("인쇄 준비 중 오류가 발생했습니다.");
      setBulkPrintMode(false);
      setBulkStudents([]);
      setBulkApprovalData({});
      setBulkPrintCooldown(0); // 에러 시 쿨다운 해제
    }
  };

  const triggerBulkPrint = useReactToPrint({
    content: () => {
      // console.log("인쇄 대상 요소:", bulkContentRef.current);
      return bulkContentRef.current;
    },
    documentTitle: `${filters.schoolYear}-${currentPeriod?.term_name}-${
      filters.hierarchyThreeId ||
      filters.hierarchyTwoId ||
      filters.hierarchyOneId
    }-반별성적표`,
    onBeforePrint: () => {
      // console.log("인쇄 시작 전 처리");
      const content = bulkContentRef.current;
      if (content) {
        content.style.width = "210mm";
        content.style.height = "auto";
      }
    },
    onAfterPrint: () => {
      // console.log("인쇄 완료 후 정리");
      setBulkPrintMode(false);
      setBulkStudents([]);
      setBulkApprovalData({});
    },
    removeAfterPrint: true,
    pageStyle: `
    @media print {
      @page {
        size: A4 portrait;
        margin: 10mm;
      }
      .no-print {
        display: none !important;
      }        
      .print-page {
        display: block;
        width: 210mm;
        margin: auto;
      }
      .page-break {
        page-break-before: always;
      }        
      .pageBreakAfter {
        page-break-before: always;
        page-break-after: avoid;
      }        
    }
    ${
      showPageNumbers
        ? `
        @page {
          @bottom-center {
            content: counter(page);
            font-size: 10pt;
            margin-bottom: 5mm;
          }
        }
      `
        : ""
    }
    body {
      counter-reset: page;
    }
    
    .print-page {
      counter-increment: page;
    }
    
    table {
      page-break-inside: auto;
    }
    
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    
    thead {
      display: table-header-group;
    }
    
    tfoot {
      display: table-footer-group;
    }
  }
  `,
  });

  const handleOpenModal = (e) => {
    const { name } = e.target;

    if (documentFormData.length < 1) {
      handleToastCenterTop(t("teacher.printingRelated.noApprovalSetting"));
      return;
    }

    const matchSchoolStage = documentFormData[0].approving_possible_names?.find(
      (name) => name === keyData[1]
    );

    if (!matchSchoolStage) {
      handleToastCenterTop(t("teacher.printingRelated.noMatchDocument"));
      return;
    }

    // 권한 체크 로직 수정
    const isApprover =
      documentFormData.some(
        (form) => form.approvalGroupMembers?.username === user.username
      ) ||
      (keyData.hr_teacher_username &&
        keyData.hr_teacher_username.some(
          (teacher) => teacher.username === user.username
        ));

    if (!isApprover) {
      handleToastCenterTop(t("teacher.printingRelated.noApprovalPermission"));
      return;
    }

    let schoolYear = "";
    let schoolTermName = "";
    let schoolStage = "";
    let studentYear = "";
    let className = "";
    let documentLabel = "";
    let studentName = "";
    let studentId = "";
    let preTitle = "";
    const bulkApproval = "일괄결재";

    // 1단계 결재권자 설정 수정
    const firstStageApprover = keyData.hr_teacher_username
      ? keyData.hr_teacher_username.find(
          (teacher) => teacher.username === user.username
        )
      : null;

    const firstStageUsername = firstStageApprover
      ? firstStageApprover.username
      : keyData.hr_teacher_username && keyData.hr_teacher_username[0]
      ? keyData.hr_teacher_username[0].username
      : "";
    const firstStageFullname = firstStageApprover
      ? firstStageApprover.tname
      : "담임";

    // approvalLines 설정 수정
    const approvalLines = [
      {
        username: firstStageUsername,
        fullname: firstStageFullname,
        stage: 1,
      },
      ...(documentFormData.some((form) => form.approvalGroupMembers)
        ? documentFormData.map((member) => ({
            username: member.approvalGroupMembers?.username,
            fullname: member.approvalGroupMembers?.user?.fullname,
            stage: member.approvalGroupMembers?.stage,
          }))
        : []), // approvalGroupMembers가 없으면 빈 배열 반환
    ];

    setApprovalLines(approvalLines);

    if (name === "approval") {
      if (
        keyData.school_year &&
        keyData[1] &&
        keyData[2] &&
        keyData[3] &&
        keyData.currentPeriod?.term_name &&
        keyData.fullname
      ) {
        schoolYear = keyData.currentPeriod.school_year;
        schoolTermName = keyData.currentPeriod.term_name;
        schoolStage = keyData["1"];
        studentYear = keyData["2"];
        className = keyData["3"];
        documentLabel = documentFormData[0].document_label;
        studentName = keyData.fullname;
        studentId = keyData.username;

        preTitle =
          schoolYear +
          "-" +
          schoolTermName +
          "-" +
          schoolStage +
          "-" +
          studentYear +
          "-" +
          className +
          "-" +
          documentLabel +
          "-" +
          studentName +
          "-" +
          studentId;

        setRequestTitle(preTitle);
        setIsModalOpen(true);
        setStudentListForApproval(
          studentList.filter((r) => r.username === studentId)
        );
      } else {
        handleToastCenterTop(t("common.messages.printAfterSelectStudent"));
      }
    } else if (name === "bulkApproval") {
      if (
        keyData.school_year &&
        keyData[1] &&
        keyData[2] &&
        keyData[3] &&
        keyData.currentPeriod?.term_name
      ) {
        schoolYear = keyData.currentPeriod.school_year;
        schoolTermName = keyData.currentPeriod.term_name;
        schoolStage = keyData["1"];
        studentYear = keyData["2"];
        className = keyData["3"];
        documentLabel = documentFormData[0].document_label;

        preTitle =
          schoolYear +
          "-" +
          schoolTermName +
          "-" +
          schoolStage +
          "-" +
          studentYear +
          "-" +
          className +
          "-" +
          documentLabel +
          "-" +
          bulkApproval;

        setStudentListForApproval(studentList);
        setRequestTitle(preTitle);
        setIsModalOpen(true);
      } else {
        handleToastCenterTop(t("teacher.printingRelated.printAfterSelect"));
      }
    }

    //2024-1-중등-7-소민-학기성적표-여중등-middle.girl@sampleschool
    //2024-1-중등-7-소민-학기성적표-일괄결재
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  if (isLoadingRegi) {
    return <LoadingInside />;
  }

  if (!hasPermission(null, "can_access", checkHrteachers(hrTeachersData))) {
    return (
      <SimpleAlertMessageBlock
        message={
          t("common.messages.homeroomAccessOnly") ||
          "담임 또는 접근 권한이 있는 사람만 접근할 수 있습니다."
        }
      />
    );
  }

  return (
    <div className="basicWidth">
      {isDataLoading && <LoadingModal />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={allFormsData}
              extraFunction={handleQueryCondition}
              itemName="form_name"
              itemLabel="form_label"
            />
          </div>
          <div className="col-12 col-md-10">
            <div className="d-flex justify-content-end flex-wrap mt-2">
              <FiltersBar
                settingData={settingData}
                handleDropdownChange={handleDropdownChange}
                filters={filters}
                studentList={studentList}
                // validateInput={validateInput}
                termPeriodData={termPeriodData}
                termId={termId}
                currentPeriod={currentPeriod}
                modifyMode={modifyMode}
                disabled={modifyMode}
              />
            </div>
            <div className="d-flex justify-content-end flex-wrap mb-3 mt-2">
              <ReportCardButtonBar
                handlePrint={handlePrint}
                handleBulkPrint={handleBulkPrint}
                handleModifyMode={handleModifyMode}
                initiateApproval={handleOpenModal}
                adminMode={adminMode}
                contentToPrint={contentToPrint}
                modifyMode={modifyMode}
                showPageNumbers={showPageNumbers}
                setShowPageNumbers={setShowPageNumbers}
                showAdditionalInfo={showAdditionalInfo}
                setShowAdditionalInfo={setShowAdditionalInfo}
                componentsToFormsData={componentsToFormsData}
                isCooldownActive={isCooldownActive}
                cooldownRemaining={cooldownRemaining}
                isDataLoading={isDataLoading}
              />
            </div>
            {!bulkPrintMode && (
              <div
                id="gradeReportPrintArea"
                className="d-flex justify-content-center print-page"
                ref={contentToPrint}
              >
                <div style={{ width: "205mm" }}>
                  {/* <table className="" style={{ width: "210mm" }}>
                <thead>
                  <tr>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="1"></td>
                    <td colSpan="1" className="p-2"> */}
                  {!isLoading &&
                    componentsToFormsData &&
                    componentsToFormsData.map((item, index) => (
                      // <div key={`${item.id}-${item.order}-${index}`}>
                      <DynamicComponentsRenderer
                        components={item.components}
                        customizedContents={item.customized_contents}
                        keyData={keyData}
                        modifyMode={modifyMode}
                        setIsLoadingModal={setIsLoadingModal}
                        key={`${item.id}-${item.order}-${index}`}
                        componentsToFormId={item.id}
                        approvalData={studentApprovalRequests}
                        showAdditionalInfo={showAdditionalInfo}
                      />
                      // </div>
                    ))}
                </div>
                {/* </td>
                    <td colSpan="1"></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>
                      <div style={{ height: "10mm" }}></div>
                    </td>
                  </tr>
                </tfoot>
              </table> */}
              </div>
            )}

            {/* 일괄 인쇄용 렌더링 영역 */}
            {bulkPrintMode && (
              <div
                ref={bulkContentRef}
                className="d-flex justify-content-center print-page"
                style={{
                  width: "210mm",
                  background: "white",
                  position: "relative",
                }}
              >
                <div
                  className="position-absolute top-0 start-0 p-2 bg-primary text-white rounded no-print"
                  style={{ zIndex: 1000 }}
                >
                  📋 일괄 인쇄 미리보기 ({bulkStudents.length}명) - 잠시 후
                  자동으로 인쇄됩니다
                </div>
                <div style={{ width: "205mm" }}>
                  {bulkStudents.map((student, studentIndex) => (
                    <div
                      key={`bulk-${student.username}`}
                      className={studentIndex > 0 ? "page-break" : ""}
                      style={{ width: "100%", marginBottom: "20px" }}
                      data-student-content={student.username}
                    >
                      {!isLoading &&
                        componentsToFormsData &&
                        componentsToFormsData.map((item, index) => (
                          <DynamicComponentsRenderer
                            components={item.components}
                            customizedContents={item.customized_contents}
                            keyData={student}
                            modifyMode={false}
                            setIsLoadingModal={setIsLoadingModal}
                            key={`bulk-${student.username}-${item.id}-${item.order}-${index}`}
                            componentsToFormId={item.id}
                            approvalData={
                              bulkApprovalData[student.username] || []
                            }
                            showAdditionalInfo={showAdditionalInfo}
                          />
                        ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <ApprovalProcess
          isModalOpen={isModalOpen}
          handleCloseModal={handleCloseModal}
          documentData={keyData}
          approvalData={approvalData}
          requestType={requestType}
          requestTitle={requestTitle}
          studentListForApproval={studentListForApproval}
          documentFormData={documentFormData}
          approvalLines={approvalLines}
          handleExtraFunction={handleExtraFunction}
        />
      )}
    </div>
  );
}
